import React, { useEffect, useRef, useState } from 'react'
import './datalist.scss'
import searchIcon from '../../../assets/chevron-down.svg'

type Option = { id: number; name: string };

interface DatalistProps {
    name: string;
    id: string;
    options: Array<Option>;
    onChange: any;
    value: any;
    onAsyncSearch?: (keyword: string) => Promise<Option[]>;
}

const Datalist = (props: DatalistProps) => {

    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState(props.value || '');
    const [filteredOptions, setFilteredOptions] = useState<Array<Option>>([]);
    const [searchValue, setSearchValue] = useState('')
    const ref: any = useRef(null);

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current?.contains(event.target)) {
                handleClose();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])

    const handleClose = () => {
        setSearchValue('')
        setIsOpen(false);
    }

    const handleOpen = () => {

        if (isOpen) {
            setSearchValue('')
        }

        setIsOpen(!isOpen);
    }

    const handleOnChange = (e: any) => {
        setSearchValue(e.target.value)
    }

    const handleOptionClick = (option: any) => {
        setSearchValue('')
        setValue(option)
        setIsOpen(false);
    }

    const filterDataAsync = async (searchValue:string) => {
        let options = await props.onAsyncSearch(searchValue);
        setFilteredOptions(options);
    }

    const filterData = async (searchValue:string) => {
      setFilteredOptions(
        props.options.filter((option) =>
          option.name.toUpperCase().includes(searchValue.toUpperCase())
        )
      );
    }

    useEffect(() => {
        props.onChange(JSON.stringify(value), props.id);
    }, [value])

    useEffect(() => {
        let timeout: any;
        if (!props.onAsyncSearch) {
            filterData(searchValue);
            return;
        }
        timeout = setTimeout(() => {
            filterDataAsync(searchValue);
        }, 1000);
        return () => clearTimeout(timeout);
    }, [searchValue]);

    return (
        <div className="a-datalist" ref={ref}>
            <button
                onClick={handleOpen}
                className="a-datalist__button"
            >
                {/* Show selected value from internal state if present, else from props, else default */}
                {(value && value.name) || (props.value && props.value.name) || 'Selecciona'}
                <img
                    src={searchIcon}
                    alt={isOpen ? 'Cerrar' : 'Abrir'}
                    className={`a-datalist__button__search-icon ${isOpen ? 'a-datalist__button__search-icon--open' : ''}`}
                />
            </button>

            {
                isOpen &&
                <div className="a-datalist__section">
                    <input
                        className="a-datalist__section__hidden"
                        type='text'
                        required
                        value={value}
                        name={props.id}
                        onChange={props.onChange}
                    ></input>
                    <input type="text" name="search" value={searchValue} placeholder="BUSCAR" onChange={handleOnChange} autoComplete="off" autoFocus />
                    <div className="a-datalist__section__options">
                        {
                            filteredOptions.map((option) => (
                                <a
                                    className="a-datalist__section__options__option"
                                    onClick={() => handleOptionClick(option)}
                                    key={option.id}
                                >
                                    {option.name}
                                </a>
                            ))
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default Datalist;